module.exports = __webpack_public_path__ + "caae164c68fd7a0c904d4e79743a9c2a.png";